import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function fetchSiteContent() {
  const response = await axios.get(`${API}/site-content`);
  return response.data;
}

export async function submitLead(payload) {
  const response = await axios.post(`${API}/leads`, payload);
  return response.data;
}